import invariant from '../../utils/invariant';
export const apolloClientInvariant = apolloClient => {
  invariant(!!apolloClient, 'An Apollo client must be present. Please pass one in explicitly or use an ApolloProvider');
};